<script>
import {mapActions, mapGetters, mapState} from 'vuex'
import ContentDetailWrapper from '@/components/common/content/ContentDetailWrapper'

export default {
  extends: ContentDetailWrapper,

  data() {
    return {
      pk: 'number'
    }
  },

  computed: {
    ...mapGetters('requests/matching/archives/requests', [
      'getRequestByNumber'
    ]),
    ...mapState('requests/matching/archives/requests', {
      'error': 'listError',
      'loading': 'listLoading',
    }),

    instance() {
      return this.getRequestByNumber(this.instanceId)
    },
  },

  methods: {
    ...mapActions('requests/matching/archives/requests', {
      retrieve: 'streamStart',
    }),
  }
}
</script>